import { render, staticRenderFns } from "./contentElementAdvice.vue?vue&type=template&id=248a3668&scoped=true"
import script from "./contentElementAdvice.vue?vue&type=script&lang=js"
export * from "./contentElementAdvice.vue?vue&type=script&lang=js"
import style0 from "./contentElementAdvice.vue?vue&type=style&index=0&id=248a3668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a3668",
  null
  
)

export default component.exports